import {
  Tooltip,
  TooltipProps,
  Typography,
  TypographyProps
} from '@mui/material'
import React from 'react'

/**
 * param `tooltipProps` is mandatory because an object with
 * at least { title: string } must be passed in for the tooltip to appear
 * (an empty string title won't render the tooltip)
 *
 * @example ```
 * const title = condition ? 'title' : ''
 * return <TruncatedTextWithTooltip tooltipProps={{ title }}>Text</TruncatedTextWithTooltip>
 * ```
 */
export const TruncatedTextWithTooltip: React.FC<
  Omit<TypographyProps, 'children'> & {
    children: React.ReactNode
    tooltipProps: Omit<TooltipProps, 'children'>
  }
> = ({ children, tooltipProps, ...rest }) => {
  return (
    <Tooltip arrow placement="top" {...tooltipProps}>
      <Typography noWrap {...rest}>
        {children}
      </Typography>
    </Tooltip>
  )
}
